// dashboard-agent-ia/src/pages/Confidentialite.js
import React from 'react'
import { Link } from 'react-router-dom'

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 48 }}>
    <h2 style={{ fontSize: 22, fontWeight: 700, color: 'white', marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>{title}</h2>
    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, lineHeight: 1.8 }}>{children}</div>
  </div>
)

export default function Confidentialite() {
  const BLUE = '#3b82f6'
  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', color: 'white', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <nav style={{ padding: '0 clamp(16px,4vw,40px)', height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg,${BLUE},#1d4ed8)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🤖</div>
          <span style={{ fontWeight: 800, fontSize: 18, color: 'white' }}>Agent <span style={{ color: BLUE }}>IA</span> Sénégal</span>
        </Link>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: 14 }}>← Retour</Link>
      </nav>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: 'clamp(40px,6vw,80px) clamp(16px,5vw,40px)' }}>
        <p style={{ color: BLUE, fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Légal</p>
        <h1 style={{ fontSize: 48, fontWeight: 800, letterSpacing: '-2px', marginBottom: 12 }}>Politique de confidentialité</h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, marginBottom: 60 }}>Dernière mise à jour : 22 avril 2025</p>

        <Section title="1. Données collectées">
          <p>Dans le cadre de l'utilisation d'Agent IA Sénégal, nous collectons les données suivantes :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}><strong style={{ color: 'white' }}>Données d'entreprise :</strong> nom, secteur, numéro WhatsApp, email, adresse</li>
            <li style={{ marginBottom: 8 }}><strong style={{ color: 'white' }}>Données de conversation :</strong> messages échangés entre vos clients et l'IA</li>
            <li style={{ marginBottom: 8 }}><strong style={{ color: 'white' }}>Données de configuration :</strong> FAQ, catalogue, modèles de messages</li>
            <li style={{ marginBottom: 8 }}><strong style={{ color: 'white' }}>Données techniques :</strong> logs d'utilisation, adresses IP</li>
          </ul>
        </Section>

        <Section title="2. Utilisation des données">
          <p>Vos données sont utilisées exclusivement pour :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}>Faire fonctionner votre assistant WhatsApp IA</li>
            <li style={{ marginBottom: 8 }}>Améliorer la qualité de nos services</li>
            <li style={{ marginBottom: 8 }}>Vous envoyer des informations importantes sur votre compte</li>
            <li style={{ marginBottom: 8 }}>Générer des statistiques anonymisées</li>
          </ul>
          <br/>
          <p>Nous ne vendons, ne louons et ne partageons jamais vos données avec des tiers à des fins commerciales.</p>
        </Section>

        <Section title="3. Intelligence Artificielle">
          <p>Les conversations de vos clients sont traitées par notre moteur IA (Groq / Llama 3.3). Ces données sont transmises de manière sécurisée et ne sont pas utilisées pour entraîner des modèles externes sans votre consentement.</p>
        </Section>

        <Section title="4. Sécurité des données">
          <p>Nous mettons en œuvre des mesures de sécurité robustes :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}>Chiffrement SSL/TLS pour toutes les communications</li>
            <li style={{ marginBottom: 8 }}>Stockage sécurisé sur MongoDB Atlas (cloud certifié)</li>
            <li style={{ marginBottom: 8 }}>Accès aux données limité aux équipes autorisées</li>
            <li style={{ marginBottom: 8 }}>Sauvegardes régulières</li>
          </ul>
        </Section>

        <Section title="5. Conservation des données">
          <p>Vos données sont conservées pendant toute la durée de votre abonnement. En cas de suppression de compte, vos données sont définitivement supprimées dans un délai de 30 jours.</p>
        </Section>

        <Section title="6. Vos droits">
          <p>Conformément aux lois en vigueur, vous disposez des droits suivants :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}>Droit d'accès à vos données personnelles</li>
            <li style={{ marginBottom: 8 }}>Droit de rectification des données inexactes</li>
            <li style={{ marginBottom: 8 }}>Droit à l'effacement (suppression de compte)</li>
            <li style={{ marginBottom: 8 }}>Droit à la portabilité de vos données</li>
          </ul>
          <br/>
          <p>Pour exercer ces droits, contactez-nous à <a href="mailto:lebinaire@gmail.com" style={{ color: BLUE }}>lebinaire@gmail.com</a> ou au +221 77 648 00 68.</p>
        </Section>

        <Section title="7. Cookies">
          <p>Notre plateforme utilise des cookies techniques essentiels au fonctionnement du service (authentification, préférences). Aucun cookie publicitaire n'est utilisé.</p>
        </Section>

        <Section title="8. Contact DPO">
          <p>Pour toute question relative à la protection de vos données personnelles :</p>
          <br/>
          <p>📧 <a href="mailto:lebinaire@gmail.com" style={{ color: BLUE }}>lebinaire@gmail.com</a></p>
          <p>📞 <a href="https://wa.me/221776480068" style={{ color: BLUE }}>+221 77 648 00 68</a></p>
          <p>📍 Dakar, Sénégal</p>
        </Section>
      </div>
      <footer style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: 'clamp(20px,4vw,40px)', textAlign: 'center' }}>
        <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>© 2025 Agent IA Sénégal by LeBinaire · <Link to="/conditions" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Conditions</Link> · <Link to="/contact" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Contact</Link></p>
      </footer>
    </div>
  )
}
